import React from 'react';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Description from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { isValid } from '@totalsoft/pure-validations-react';
import AutomaticStateTransitionGeneralDataComponent from './AutomaticStateTransitionGeneralDataComponent';

export const AutomaticStateTransitionGeneralDataCard = ({
  automaticStateTransition,
  docTypes,
  states,
  validation,
  onSave,
  onPropertyChanged
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={Description}
      iconColor='primary'
      title={t('AutomaticStateTransitions.GeneralInfo')}
      actions={
        <IconButton
          color='transparent'
          fontSize='medium'
          type='save'
          tooltip={t('AutomaticStateTransitions.Save')}
          onClick={onSave}
          disabled={!automaticStateTransition.changed || !(validation |> isValid)}
        />
      }
    >
      <>
        <Prompt when={automaticStateTransition.changed} message={t('AutomaticStateTransitions.LeavingWithoutSavingTransition')} />
        <AutomaticStateTransitionGeneralDataComponent
          automaticStateTransition={automaticStateTransition}
          docTypes={docTypes}
          states={states}
          onPropertyChanged={onPropertyChanged}
          validation={validation}
        />
      </>
    </Card>
  );
};

AutomaticStateTransitionGeneralDataCard.propTypes = {
  automaticStateTransition: PropTypes.object.isRequired,
  docTypes: PropTypes.array.isRequired,
  states: PropTypes.object,
  validation: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired
};

export default AutomaticStateTransitionGeneralDataCard;
